import { Link } from 'react-router-dom'
import { FaCertificate } from 'react-icons/fa'
import s from '../DealsByCompanies.scss'

const TabContent = ({ companies, dealAwardedCompany }) => {
  if (!companies.length) {
    return <p style={{ textAlign: 'center' }}>No opportunities</p>
  }
  return companies.map(company => (
    <div key={company.id} className={s.dealsByCompanySection}>
      <p>
        {company.id === dealAwardedCompany?.value && (
          <FaCertificate className={s.awardIcon} title="Opportunity Awarded" />
        )}
        {company.name}
      </p>
      {company.deals.map(deal => (
        <div key={deal.id}>
          <Link to={`/opportunities/${deal.id}`} target="_blank" rel="noopener noreferrer">
            {deal.name}
          </Link>{' '}
          <span>{deal.status?.name}</span> - <span>{deal.dealManager?.userName}</span>
        </div>
      ))}
    </div>
  ))
}

export default TabContent
